import { render } from "./edit_decoration.vue?vue&type=template&id=5ac90c5a&scoped=true"
import script from "./edit_decoration.vue?vue&type=script&lang=js"
export * from "./edit_decoration.vue?vue&type=script&lang=js"

import "./edit_decoration.vue?vue&type=style&index=0&id=5ac90c5a&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac90c5a"]])

export default __exports__